module.exports = __webpack_public_path__ + "ac7f1ffea58f81eb3dcf3bfa1557f39f.woff2";